export const FILTER_MODAL_URL_PARAM = "filter";
